import {
    ApiHandlerDiscreteParameter,
    createHandlerChainRunner,
    HasOnSuccess,
    markSkipOnCompleteIfOnSuccessIsSet,
} from "@insite/client-framework/HandlerCreator";
import { ApiParameter, post } from "@insite/client-framework/Services/ApiService";
import { LeadOption } from "@ucs/Helpers/Enums";

type SubmitContactFormParameter = {
    emailRecipients: string;
} & HasOnSuccess;

interface SubmitContactUsFormApiParameter extends ApiParameter {
    topic?: string;
    firstName?: string;
    lastName?: string;
    phoneNumber?: string;
    emailAddress?: string;
    message?: string;
    emailTo?: string;
    companyName?: string;
    consent?: string;
    location?: string;
}

type HandlerType = ApiHandlerDiscreteParameter<SubmitContactFormParameter, SubmitContactUsFormApiParameter>;

const emailsUrl = "/api/v1/email";
const emailsUrlExtension = "/api/v1/emailExtensions";

export const isCompanyNameRequired = (topic: string) => {
    return !!Object.values(LeadOption).find(val => val === topic.toUpperCase());
};

export function ucsSubmitContactUsForm(parameter: SubmitContactUsFormApiParameter) {
    return isCompanyNameRequired(parameter.topic || "")
        ? post<SubmitContactUsFormApiParameter, void>(`${emailsUrlExtension}/contactUs`, parameter)
        : post<SubmitContactUsFormApiParameter, void>(`${emailsUrlExtension}/contactUs`, parameter);
}

export const PopulateApiParameter: HandlerType = props => {
    const state = props.getState().components.contactUsForm;

    const consent = `<br><br><b>Marketing Email Opt-In:</b> ${state.fieldValues["consent"] ? "Yes" : "No"}`;
    let companyName = "";
    if (state.fieldValues["topic"] && isCompanyNameRequired(state.fieldValues["topic"])) {
        companyName = `<br><br><b>Company:</b> ${state.fieldValues["companyName"]}`;
    }

    props.apiParameter = {
        firstName: state.fieldValues["firstName"],
        lastName: state.fieldValues["lastName"],
        message: state.fieldValues["message"] + consent + companyName,
        topic: state.fieldValues["topic"],
        phoneNumber: state.fieldValues["phoneNumber"],
        emailAddress: state.fieldValues["emailAddress"],
        emailTo: props.parameter.emailRecipients,
        companyName: state.fieldValues["companyName"],
        consent: state.fieldValues["consent"],
        location: state.fieldValues["selectedLocation"],
    };
};

export const SendDataToApi: HandlerType = async props => {
    await ucsSubmitContactUsForm(props.apiParameter);
};

export const ExecuteOnSuccessCallback: HandlerType = props => {
    markSkipOnCompleteIfOnSuccessIsSet(props);
    props.parameter.onSuccess?.();
};

export const chain = [PopulateApiParameter, SendDataToApi, ExecuteOnSuccessCallback];

const ucsSubmitContactForm = createHandlerChainRunner(chain, "ucsSubmitContactForm");
export default ucsSubmitContactForm;
